import React from 'react';
// import Carousel from '../carousel/carousel';

class Mantra_18_Canvas extends React.Component {
    constructor() {
        super();
        this.state = {

        }
    }


    render() {
        const { name } = this.props;


        return (
            <section className="canvas_section mantra18_canvas setdiv_canvas" id={"canvas_generate_" + this.props.module_name} >
                {/* <Carousel /> */}
                <div className="m3_a1_container container">

                    <section className="mantra18_prev_section">
                        <img src="/assets/img/mantra18_cirt.png" className="m18_cirt" />
                        <h6 className="m18_txt1">As an Exam Warrior, I</h6>
                        <h6 className="m18_txt_name">{name}</h6>
                        <h6 className="m18_txt1">
                            Pledge that i will not cheat and will
                            demonstrate honesty in everything I do.
                            </h6>
                        <div className="text-center">
                            <img src="/assets/img/m18_kh.png" className="m18_kh" />
                        </div>
                        <div className="text-center m18_btm_txt">
                        <div className="m18_b_txt_wrp">
                                 <span className="m18_txt_name2">{name}</span></div>
                            <h3>Student's Signature</h3>
                            <h4>"To Cheat is to be Cheap"</h4>
                            <h5>Narendra Modi</h5>
                            <h6>Prime Minister</h6>
                        </div>
                    </section>
                </div>

            </section>
        )
    }
}

export default Mantra_18_Canvas;